import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ConnectionWarningBanner } from "./ConnectionWarningBanner";
import { SiteFooter } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";

export function SiteLayout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[--page-bg] text-stone-950">
      <a
        href="#content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-stone-950"
      >
        Перейти к содержанию
      </a>

      <div className="pointer-events-none fixed inset-0 opacity-90">
        <div className="edge-ribbon edge-ribbon-left" />
        <div className="edge-ribbon edge-ribbon-right" />
        <div className="ornament ornament-left" />
        <div className="ornament ornament-right" />
      </div>

      <SiteHeader />
      <ConnectionWarningBanner />
      <main id="content" className="relative z-10">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
